<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
 import {mapState,mapMutations,mapAction } from 'vuex'
export default {
  name: "app",
  mounted() {
    //console.log(this.$refs.vetable)
    window.onresize = () => {
      return (() => {
          //console.log("变化了")
           const windheight = window.innerHeight;
           this.getWindowHeight({windheight})

      })();
    };
    if (this._isMobile()) {
        // alert("手机端");
        localStorage.setItem('flagShow',1) ;
      }
  },
  created() {

    this.$veLocale.use(zhCN);
    const windheight = window.innerHeight;
   this.getWindowHeight({windheight})
  },
  methods: {
    ...mapMutations(['getWindowHeight']),
    _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    }
  },
  components: {},
};
</script>

<style>
.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td, .ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td{
padding: 5px 0 !important;
}
.ve-dropdown-popper {
    z-index: 2200 !important;
}
#app{
 overflow-y:auto;
  --bg-color : orange;
  --font-color:#fff
}
/* 表头样式全局兜底：ve-table 各列表页的表头 class 原先分散在各懒加载页面里定义，
   直接刷新（F5）进入某页时若定义页面的 chunk 未加载、或 CSS 变量解析时机异常，
   表头背景色会丢失；此处把变量提升到 :root 并在根组件（恒加载、非 scoped）集中定义一份，
   任何页面刷新后表头样式均有保障 */
:root{
  --bg-color : orange;
  --font-color:#fff
}
.table-header-cell-class {
  background: var(--bg-color, orange) !important;
  color: var(--font-color, #fff) !important;
  border-right: 0px !important;
}
.empty-data {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
        width: 100%;
        color: #666;
        font-size: 16px;
        border: 1px solid #eee;
        border-top: 0;
    }
.table-pagination {
        margin-top: 20px;
        text-align: center;
    }
.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
  padding: 10px;
}
* {
  box-sizing: border-box;

  padding: 0;

  margin: 0;
}
html {
  margin: 0;

  height: 100%;

  width: 100%;
}
#app {
  height: 100%;

  width: 100%;
  overflow-y: hidden;
}
#WHnum {
  width: 100%;
  height: 100%;
}
.tablemain {
  width: 97%;
  height: auto;           /* 原90%定高会把容器撑到视口外(表格max-height再准也无济):改为跟随内容自适应 */
  margin: 0 auto;
  overflow: hidden;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
}
.expandFrom {
  padding: 10px 40px;
}
.tablecss {
  width: 100%;
  /* height: 100%; */
   padding: 10px;
    /* height: calc(100% - 30px);  */
  overflow: hidden;
}
.el-table {
  font-size: 12px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.tablecss /deep/ .el-table .cell {
    overflow: hidden;
    text-decoration: solid;
    padding: 0 !important;
    max-height:100px;
    line-height: 24px !important
  }
  .tablecss /deep/ .el-table .el-table__cell{
    padding:0;
  }
  .el-table .el-table__cell{
    overflow: hidden;
    text-decoration: solid;
    padding: 0 !important;
    max-height:100px;
    line-height: 24px !important
  }
  .tablecss /deep/ .el-pagination__total{
    margin-left: 30%;
  }
  .ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content thead.ve-table-header tr.ve-table-header-tr th.ve-table-header-th{
    padding: 0px !important;
  }

  /* ===== 筛选栏标准布局（全站列表页通用） =====
     用法：筛选容器加 class="filter-bar"，按钮组包一层 <div class="filter-actions">
     效果：查询组件从左往右流动换行；按钮组永远贴容器右下角——
           一行放得下时贴右侧，放不下时换行到右下角，查询组件继续补充上一行/本行左侧空位。
     间距纪律：组件间统一靠 gap，查询组件不要再手写 margin-left/right */
  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;                  /* 行/列统一间距,替代零散手写 margin */
    background: #f5f7fa;
    border-radius: 4px;
    padding: 12px 16px;
    margin: 8px auto;           /* 与 .tablemain 同宽(97%)同水平居中,筛选卡与表格逐像素对齐 */
    width: 97%;
  }

  .filter-bar .filter-actions {
    margin-left: auto;          /* 按钮组推到当前行最右；本行放不下则整体换行仍贴右 */
    display: flex;
    align-items: center;
    gap: 10px;                  /* 按钮间距 */
    white-space: nowrap;        /* 按钮组自身不内部换行 */
    padding-right: 4px;
  }

</style>
